import { generateApiPath } from "@routes/generatePath.ts";

const pathBase = `/medical-service-provider/services`;

export const services = {
  get: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
};
